//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Preferences.js";
import "../no/Object.js";
import "../Preferences/Preferences.RoutingApplicationView.js";
let d=[[[0,"BomDetailLevelFlag",1,0],[0,"BomFormatPart",1,0],[0,"DefaultElbowNode",1,0],[0,"FabricationNumberingFlag",1,0],[0,"InvalidSequenceCharacters",1,0],[0,"Layer",1,0],[0,"MaximumSolutions",1,0],[0,"PreferredPortMethodFlag",0,0],[0,"StockLengthDisplayFlag",1,0],[0,"UsePreferredPortFlag",1,0]],[[["desired_port"],"SetPreferredPortName",{},1,0],[[],"GetPreferredPortName",{R_:{desired_port:''}},0,0],[["attribute_name","attribute_value"],"SetPreferredPortAttribute",{},2,0],[["attribute_name","attribute_value"],"GetPreferredPortAttribute",{},0,0]],[["PartLibrary","Preferences.RoutingPartLibrary",0]]];
SPLM.Preferences.RoutingPart = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Preferences.RoutingPart";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Preferences.RoutingPart.UsePreferredPort = Object.freeze({
    "False" : "False", "True" : "True"});

SPLM.Preferences.RoutingPart.PreferredPortMethod = Object.freeze({
    "Attribute" : "Attribute", "Name" : "Name"});

SPLM.Preferences.RoutingPart.DetailLevel = Object.freeze({
    "Summary" : "Summary", "Itemized" : "Itemized"});

SPLM.Preferences.RoutingPart.FabricationNumbering = Object.freeze({
    "Sequence" : "Sequence", "Original" : "Original"});

SPLM.Preferences.RoutingPart.StockLengthDisplay = Object.freeze({
    "Sum" : "Sum", "Item" : "Item"});

export default SPLM;